module.exports = __webpack_public_path__ + "img/charter-2.95fae91.webp";